import React from 'react'
import Link from 'gatsby-link'
import IT_logo from './IT.png'
import Netia_logo from './netia.png'
import t_mobile_logo from './T-mobile.png'
import Telestrada_logo from './telestrada.png'

class Footer extends React.Component {
  render() {
    return (
		<div className="site-footer">
      <div className="site-info">
      </div>
    </div>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js